import { call, put, takeEvery } from "redux-saga/effects"
import _ from 'lodash';

// Crypto Redux States
import { GET_COMBOS , ADD_NEW_COMBO , UPDATE_COMBO } from "./actionTypes"

import {
  getCombosSuccess
} from "./actions"

//Include Both Helper File with needed methods
import { API_ENDPOINTS } from "api/endpoints"
import { history } from "helpers/utils"
import { Toast } from "helpers/Toast"


function* fetchCombos(data) {
  try {
    const response = yield call(API_ENDPOINTS.getCombosList, {queryStringParameters: data.payload})
    yield put(getCombosSuccess(response))
  } catch (error) {
    Toast('error', error)
  }
}


function* onAddNewCombo(data) {
  try {
    let res = yield call(API_ENDPOINTS.createOrEditCombo, {body: data.payload})
  } catch (error) {
    Toast('error', error)
  }
}

function* updateComboDetail(data) {
  try {
    let body = {
      body: data.payload,
      queryStringParameters: {
        imageId: data.payload._id
      }
    }
    yield call(API_ENDPOINTS.createOrEditCombo, body)

  } catch (error) {
    console.log('error', error)
    Toast('error', error)
  }
}

function* wordsSaga() {
  yield takeEvery(GET_COMBOS, fetchCombos)
  yield takeEvery(ADD_NEW_COMBO, onAddNewCombo)
  yield takeEvery(UPDATE_COMBO, updateComboDetail)
}

export default wordsSaga;
